import { candidateService } from '@/services/public/candidate.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { candidateModel } from '@/models/api/candidate.model';

export const state = {
    details: {},
    status: {
        detail: true,
        save: true,
    },
};

export const CANDIDATE_MODULE = "public/candidate";

// ACTIONS
export const CREATE_CANDIDATE = 'createCandidate';
export const GET_CANDIDATE = 'getCandidate';
export const UPDATE_CANDIDATE = 'updateCandidate';
export const CREATE_CANDIDATE_USER = 'createCandidateUser';

// MUTATIONS
const REQUESTING = "requesting";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_CANDIDATE_SUCCESS = "getCandidateSuccess";

export const actions = {
    [CREATE_CANDIDATE_USER]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return candidateService
            .createCandidateUser(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_CANDIDATE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return candidateService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_CANDIDATE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return candidateService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_CANDIDATE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_CANDIDATE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return candidateService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};

export const mutations = {
    [GET_CANDIDATE_SUCCESS](state, data) {
        state.details = candidateModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            detail: true,
            save: true,
        };
    },
};
